import { render } from "./HeaderStore.vue?vue&type=template&id=cedcb892&scoped=true"
import script from "./HeaderStore.vue?vue&type=script&lang=js"
export * from "./HeaderStore.vue?vue&type=script&lang=js"

import "@/assets/scss/_header-store.scss?vue&type=style&index=0&id=cedcb892&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cedcb892"]])

export default __exports__